import type { CurrencyId } from "@/services/currencies";
import type { LanguageId } from "@/services/translation";
import type { UserFlag } from "@/services/user/settings/flags";
import type { UserSettings_Schema } from "@/services/user/settings/userSettingsSchema";
import type { z } from "zod";

export type UserSettings = z.infer<typeof UserSettings_Schema>;

export type UpdateUserSettingsData = Partial<{
  nickname: string;
  nicknameDaysTillNew: number;
  publicFullName: string;
  publicEmail: string;
  publicPhone: string;
  publicUrlFacebook: string;
  publicUrlInstagram: string;
  publicUrlTikTok: string;
  publicUrlPinterest: string;
  publicUrlWeb: string;
  publicBioDescription: string;
  flags: Array<keyof typeof UserFlag>;
  isChatEmailNotificationEnabled: boolean;
  displayLanguageId: LanguageId;
  displayCurrencyId: CurrencyId;
  holidayUntil: string | null;
}>;

export enum UserSettingsAnchor {
  Verification = "verification",
  Absence = "absence",
  BasicInfo = "basic-info",
  Password = "password",
  Localization = "localization",
  EmailNotifications = "email-notifications",
}
